"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var __1 = require("..");
var config_1 = require("../config");
exports.arpHook = function (id, options) {
    var _a = config_1.getAthleteAPIClientConfig(), useEffect = _a.useEffect, useState = _a.useState;
    var token = options.token, fetchToken = options.fetchToken;
    var _b = useState(undefined), arp = _b[0], setARP = _b[1];
    useEffect(function () {
        var isSubscribed = true;
        console.log(arp);
        var arpHandler = function (arpResponse) {
            if (isSubscribed) {
                setARP(arpResponse);
            }
        };
        if (token) {
            __1.getARP(id, token).then(arpHandler);
        }
        if (fetchToken) {
            fetchToken().then(function (actualToken) {
                return __1.getARP(id, actualToken).then(arpHandler);
            });
        }
        return function () { return isSubscribed = false; };
    }, []);
    return arp;
};
//# sourceMappingURL=arpHook.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/athlete-api-client/dist/hooks/arpHook.js
 ** module id = 2068
 ** module chunks = 0
 **/